<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>

<template>
  <!-- SITEUP V2 / G2: linha kv — rótulo muted min 62px, valor 13.5 à direita -->
  <div
    class="flex items-start justify-between gap-2.5"
    :class="compact ? 'mb-2 py-0' : 'mb-2 py-0.5 last:mb-0'"
  >
    <span
      class="min-w-[62px] shrink-0 text-[12.5px] leading-snug text-n-slate-11"
    >
      {{ title }}
    </span>
    <div
      v-if="value || $slots.default"
      class="min-w-0 flex-1 break-words text-right text-[13.5px] font-medium leading-snug text-n-slate-12"
    >
      <slot>
        {{ value }}
      </slot>
    </div>
    <div class="flex shrink-0 items-center">
      <slot name="button" />
    </div>
  </div>
</template>
